import { HStack, Select, Input } from '@chakra-ui/react'
import type { ReportFilters as Filters } from '@/lib/services/helpdeskReportService'

type Props = {
  filters: Filters
  onChange: (next: Filters) => void
  showGroupBy?: boolean
}

export default function ReportFilters({ filters, onChange, showGroupBy }: Props) {
  return (
    <HStack spacing={3} flexWrap="wrap">
      <Input
        type="date"
        size="sm"
        width="auto"
        value={filters.from ?? ''}
        onChange={(e) => onChange({ ...filters, from: e.target.value || undefined })}
        placeholder="From"
      />
      <Input
        type="date"
        size="sm"
        width="auto"
        value={filters.to ?? ''}
        onChange={(e) => onChange({ ...filters, to: e.target.value || undefined })}
        placeholder="To"
      />
      {showGroupBy && (
        <Select
          size="sm"
          width="140px"
          value={filters.group_by ?? 'day'}
          onChange={(e) => onChange({ ...filters, group_by: e.target.value as 'day' | 'week' })}
        >
          <option value="day">By day</option>
          <option value="week">By week</option>
        </Select>
      )}
    </HStack>
  )
}
